import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormControl, ControlLabel } from 'react-bootstrap';
import Button from './Button';

const ensureHeader = (activeHeaders, inactiveHeaders, header) => {
    let index = activeHeaders.findIndex(h => h.name === header.name && h.table === header.table);
    if (index >= 0) {
        activeHeaders[index] = header;
        return;
    }

    index = inactiveHeaders.findIndex(h => h.name === header.name && h.table === header.table);
    if (index >= 0) {
        inactiveHeaders[index] = header;
        return;
    }

    inactiveHeaders.push(header);
};

class EditTableHeaders extends PureComponent {
    constructor(props) {
        super(props);
        this.onActiveHeadersChange = this.onActiveHeadersChange.bind(this);
        this.onInactiveHeadersChange = this.onInactiveHeadersChange.bind(this);
        this.moveAllInactiveHeadersToActiveHeaders = this.moveAllInactiveHeadersToActiveHeaders.bind(this);
        this.moveAllActiveHeadersToInactiveHeaders = this.moveAllActiveHeadersToInactiveHeaders.bind(this);
        this.moveSelectedActiveHeadersToInactiveHeaders = this.moveSelectedActiveHeadersToInactiveHeaders.bind(this);
        this.moveSelectedInactiveHeadersToActiveHeaders = this.moveSelectedInactiveHeadersToActiveHeaders.bind(this);
        this.moveSelectedActiveHeadersUp = this.moveSelectedActiveHeadersUp.bind(this);
        this.moveSelectedActiveHeadersDown = this.moveSelectedActiveHeadersDown.bind(this);
        this.updateInactiveHeaders = this.updateInactiveHeaders.bind(this);
        this.move = this.move.bind(this);
        this.getActiveHeaders = this.getActiveHeaders.bind(this);
        this.state = {
            activeHeaders: [],
            inactiveHeaders: [],
        };
    }

    componentDidMount() {
        this.updateInactiveHeaders(this.props.activeHeaders);
    }

    componentWillReceiveProps(nextProps) {
        this.updateInactiveHeaders(nextProps.activeHeaders);
    }

    getActiveHeaders() {
        return this.state.activeHeaders;
    }

    move(from, to, selectedOnly = false) {
        let fromNew = [];
        let toNew = [...to];
        for (let i = 0; i < from.length; i++) {
            let fromHeader = from[i];
            if (selectedOnly && !fromHeader.selected) {
                fromNew.push(fromHeader);
                continue;
            }

            if (to.findIndex(header => {
                    return header.table == fromHeader.table &&
                           header.name == fromHeader.name;
                }) == -1) {

                fromHeader.selected = false;
                if (selectedOnly) {
                    toNew.unshift(fromHeader);

                } else {
                    toNew.push(fromHeader);
                }

            } else {
                fromNew.push(fromHeader);
            }
        }

        return {
            from: fromNew,
            to: toNew
        }
    }

    onActiveHeadersChange(evt) {
        let activeHeaders = [...this.state.activeHeaders];
        for (let i = 0; i < activeHeaders.length; i++) {
            activeHeaders[i].selected = !!evt.target[i].selected;
        }

        this.setState({activeHeaders});
    }

    onInactiveHeadersChange(evt) {
        let inactiveHeaders = [...this.state.inactiveHeaders];
        for (let i = 0; i < inactiveHeaders.length; i++) {
            inactiveHeaders[i].selected = !!evt.target[i].selected;
        }

        this.setState({inactiveHeaders});
    }

    moveAllInactiveHeadersToActiveHeaders(evt) {
        let {
            activeHeaders,
            inactiveHeaders
        } = this.state;

        let moved = this.move(inactiveHeaders, activeHeaders);
        this.setState({
            inactiveHeaders: [...moved.from],
            activeHeaders: [...moved.to]
        });
    }

    moveAllActiveHeadersToInactiveHeaders(evt) {
        this.updateInactiveHeaders([]);
    }

    moveSelectedActiveHeadersToInactiveHeaders(evt) {
        let selectedHeaders = this.state.activeHeaders.filter(header => {
            return !!header.selected;
        });

        let activeHeaders = this.state.activeHeaders.filter(header => {
            return !header.selected;
        });

        let moved = this.move(selectedHeaders, this.state.inactiveHeaders, true);
        this.setState({
            activeHeaders: [...activeHeaders],
            inactiveHeaders: [...moved.to]
        });
    }

    moveSelectedInactiveHeadersToActiveHeaders(evt) {
        let selectedHeaders = this.state.inactiveHeaders.filter(header => {
            return !!header.selected;
        });

        let inactiveHeaders = this.state.inactiveHeaders.filter(header => {
            return !header.selected;
        });

        let moved = this.move(selectedHeaders, this.state.activeHeaders, true);
        this.setState({
            activeHeaders: [...moved.to],
            inactiveHeaders: [...inactiveHeaders]
        });
    }

    moveSelectedActiveHeadersUp(evt) {
        let activeHeaders = this.state.activeHeaders;
        for (let i = 1; i < activeHeaders.length; i++) {
            if (activeHeaders[i].selected && !activeHeaders[i-1].selected) {
                let tmpHeader = activeHeaders[i-1];
                activeHeaders[i-1] = activeHeaders[i];
                activeHeaders[i] = tmpHeader;
            }
        }

        this.setState({activeHeaders}, () => {
            this.forceUpdate();
        });
    }

    moveSelectedActiveHeadersDown(evt) {
        let activeHeaders = this.state.activeHeaders;
        for (let i = activeHeaders.length - 2; i >= 0; i--) {
            if (activeHeaders[i].selected && !activeHeaders[i+1].selected) {
                let tmpHeader = activeHeaders[i+1];
                activeHeaders[i+1] = activeHeaders[i];
                activeHeaders[i] = tmpHeader;
            }
        }

        this.setState({activeHeaders}, () => {
            this.forceUpdate();
        });
    }

    updateInactiveHeaders(activeHeaders = []) {
        const {
            workflow,
            filterTable,
            filterWorkflow
        } = this.props;

        let inactiveHeaders = [];
        if (workflow) {
            for (let k = 0; k < workflow.length; k++) {
                let currentWorkflow = workflow[k];
                if ((filterWorkflow && filterWorkflow !== currentWorkflow.type) ||
                    !currentWorkflow.tables ) {

                    continue;
                }

                for (let i = 0; i < currentWorkflow.tables.length; i++) {
                    let table = currentWorkflow.tables[i].table;
                    if (filterTable && filterTable !== table) {
                        continue;
                    }

                    for (let j = 0; j < currentWorkflow.tables[i].fields.length; j++) {
                        let field = currentWorkflow.tables[i].fields[j];
                        if (activeHeaders.findIndex(header => {
                            return header.table === table && header.name == field.name;
                        }) !== -1) {
                            continue;
                        }

                        if (inactiveHeaders.findIndex(header => {
                            return header.table === table && header.name == field.name;
                        }) !== -1) {
                            continue;
                        }

                        let label = '';
                        if (field.props && field.props.label) {
                            label = field.props.label;
                        }

                        if (!label) {
                            continue;
                        }

                        let header = {
                            table,
                            name: field.name,
                            label: label,
                            width: 150
                        };

                        inactiveHeaders.push(header);
                    }
                }
            }

            ensureHeader(activeHeaders, inactiveHeaders, { 
                table: 'intake',
                name: 'PublicIntakeDate',
                label: 'External Intake Date',
                width: 150,
            });

            ensureHeader(activeHeaders, inactiveHeaders, {
                table: 'intake',
                name: 'PublicIntakeSourceHost',
                label: 'External Website',
                width: 150,
            });

            ensureHeader(activeHeaders, inactiveHeaders, {
                table: 'intake',
                name: 'PublicIntakeSourceFullUrl',
                label: 'External Website (full URL)',
                width: 150,
            });

            ensureHeader(activeHeaders, inactiveHeaders, {
                table: 'intake',
                name: 'AssignedTo',
                label: 'Case Manager',
                width: 150,
            });

            inactiveHeaders = inactiveHeaders.sort((a, b) => {
                let keyA = `${a.table}.${a.name}`;
                let keyB = `${b.table}.${b.name}`;
                return keyA.localeCompare(keyB);
            });
        }

        this.setState({
            activeHeaders,
            inactiveHeaders
        });
    }

    renderList(id, headers, onChange) {
        // The same label can exist in several tables: tell those apart by their table.
        const counts = _.countBy(headers, h => h.label);
        return (
            <FormControl componentClass="select"
                         id={id}
                         multiple
                         className="ct-columns__list"
                         disabled={headers.length === 0}
                         onChange={onChange}>
                {headers.map((header) => {
                    const key = `${header.table}.${header.name}`;
                    return (<option key={key} value={key} title={key}>{counts[header.label] > 1 ? `${header.label} (${header.table})` : header.label}</option>);
                })}
            </FormControl>
        );
    }

    render() {
        const { activeHeaders, inactiveHeaders } = this.state;
        return (
            <div className="ct-columns">
                <div className="ct-columns__pane">
                    <ControlLabel htmlFor="inactiveHeaders">Available ({inactiveHeaders.length})</ControlLabel>
                    {this.renderList('inactiveHeaders', inactiveHeaders, this.onInactiveHeadersChange)}
                </div>
                <div className="ct-columns__move">
                    <Button onClick={this.moveAllInactiveHeadersToActiveHeaders}
                            icon="forward"
                            tooltip="Show all columns"/>
                    <Button onClick={this.moveSelectedInactiveHeadersToActiveHeaders}
                            icon="chevron-right"
                            tooltip="Show selected columns"/>
                    <Button onClick={this.moveSelectedActiveHeadersToInactiveHeaders}
                            icon="chevron-left"
                            tooltip="Hide selected columns"/>
                    <Button onClick={this.moveAllActiveHeadersToInactiveHeaders}
                            icon="backward"
                            tooltip="Hide all columns"/>
                </div>
                <div className="ct-columns__pane">
                    <ControlLabel htmlFor="activeHeaders">Visible, in order ({activeHeaders.length})</ControlLabel>
                    {this.renderList('activeHeaders', activeHeaders, this.onActiveHeadersChange)}
                </div>
                <div className="ct-columns__move">
                    <Button onClick={this.moveSelectedActiveHeadersUp}
                            icon="arrow-up"
                            tooltip="Move selected visible columns up"/>
                    <Button onClick={this.moveSelectedActiveHeadersDown}
                            icon="arrow-down"
                            tooltip="Move selected visible columns down"/>
                </div>
            </div>
        );
    }
}

EditTableHeaders.propTypes = {
    activeHeaders: PropTypes.array.isRequired,
    workflow: PropTypes.array.isRequired,
    filterTable: PropTypes.string,
    filterWorkflow: PropTypes.string
}

export default EditTableHeaders;
